<template>
  <Banner></Banner>
  <EventIntro></EventIntro>
  <Issues></Issues>
  <Teachers></Teachers>
  <Keynote></Keynote>
  <Giveaway></Giveaway>
  <Organizer></Organizer>
</template>

<script>
import Banner from "./Banner.vue";
import EventIntro from "@/components/home/EventIntro.vue";
import Issues from "@/components/home/Issues.vue";
import Teachers from "@/components/home/Teachers.vue";
import Keynote from "@/components/home/Keynote.vue";
import Giveaway from "@/components/home/Giveaway.vue";
import Organizer from "@/components/home/Organizer.vue";

import { footerStore } from '@/stores/footerStore';

export default {
  components: {
    Banner,
    EventIntro,
    Issues,
    Teachers,
    Keynote,
    Giveaway,
    Organizer,
  },
  data() {
    return {
      color: '#edf3f9'
    }
  },
  methods: {
    setBackground() {
      footerStore().setBackground(this.color)
    }
  },
  created() {
    this.setBackground()
  }
};
</script>
